import { render } from "./Empty.vue?vue&type=template&id=745e36d2"
const script = {}

import "./Empty.vue?vue&type=style&index=0&id=745e36d2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__